import { render, staticRenderFns } from "./RegistrationByPkw.vue?vue&type=template&id=481e00c3&"
import script from "./RegistrationByPkw.vue?vue&type=script&lang=js&"
export * from "./RegistrationByPkw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports